import http from './http';
import DefaultDate from '../filters/DefaultDate';

export default {
    getAll() {
        return http.get('/substance');
    },
    getSingle(id, date, raw = false) {
        const formattedDate = raw ? date : DefaultDate(date);

        return http.get(`/substance/${id}?datetime=${formattedDate}`);
    },
    getSingleVersions(id) {
        return http.get(`/substance/${id}/versions`);
    },
    create(substance) {
        return http.post('/substance', substance);
    },
    update(substance) {
        return http.put(`/substance/${substance.info.id}`, substance);
    },
    newVersion(substance) {
        return http.put(`/substance/${substance.info.id}/newversion`, substance);
    },
};
